<template>
  <div class="text-black mb-3">
    <div v-if="!showDetail">
      <div class="mb-0 text-blue-800 text-base flex justify-end">
        <!-- <div class="text-black fs-14 mr-3 cursor-pointer fw-600" @click="showModal(true)">
          <svg
            class="mr-1"
            width="16"
            height="16"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.039 5.13579L8.1 3.06528V11.6984C8.1 11.9372 8.19482 12.1662 8.3636 12.335C8.53239 12.5038 8.76131 12.5987 9 12.5987C9.23869 12.5987 9.46761 12.5038 9.6364 12.335C9.80518 12.1662 9.9 11.9372 9.9 11.6984V3.06528L11.961 5.13579C12.0447 5.22017 12.1442 5.28714 12.2539 5.33284C12.3636 5.37855 12.4812 5.40208 12.6 5.40208C12.7188 5.40208 12.8364 5.37855 12.9461 5.33284C13.0558 5.28714 13.1553 5.22017 13.239 5.13579C13.3234 5.05211 13.3903 4.95254 13.436 4.84284C13.4817 4.73314 13.5052 4.61547 13.5052 4.49663C13.5052 4.37779 13.4817 4.26013 13.436 4.15043C13.3903 4.04073 13.3234 3.94116 13.239 3.85747L9.639 0.256576C9.55341 0.174619 9.45248 0.110375 9.342 0.067529C9.12288 -0.0225097 8.87712 -0.0225097 8.658 0.067529C8.54752 0.110375 8.44659 0.174619 8.361 0.256576L4.761 3.85747C4.67709 3.94141 4.61052 4.04106 4.56511 4.15072C4.51969 4.26039 4.49632 4.37793 4.49632 4.49663C4.49632 4.61534 4.51969 4.73288 4.56511 4.84254C4.61052 4.95221 4.67709 5.05186 4.761 5.13579C4.84491 5.21973 4.94454 5.28631 5.05418 5.33173C5.16382 5.37716 5.28133 5.40054 5.4 5.40054C5.51867 5.40054 5.63618 5.37716 5.74582 5.33173C5.85546 5.28631 5.95509 5.21973 6.039 5.13579ZM17.1 8.99776C16.8613 8.99776 16.6324 9.0926 16.4636 9.26142C16.2948 9.43025 16.2 9.65922 16.2 9.89798V15.2993C16.2 15.5381 16.1052 15.7671 15.9364 15.9359C15.7676 16.1047 15.5387 16.1996 15.3 16.1996H2.7C2.4613 16.1996 2.23239 16.1047 2.0636 15.9359C1.89482 15.7671 1.8 15.5381 1.8 15.2993V9.89798C1.8 9.65922 1.70518 9.43025 1.5364 9.26142C1.36761 9.0926 1.13869 8.99776 0.9 8.99776C0.661305 8.99776 0.432387 9.0926 0.263604 9.26142C0.0948211 9.43025 0 9.65922 0 9.89798V15.2993C0 16.0156 0.284464 16.7025 0.790812 17.209C1.29716 17.7155 1.98392 18 2.7 18H15.3C16.0161 18 16.7028 17.7155 17.2092 17.209C17.7155 16.7025 18 16.0156 18 15.2993V9.89798C18 9.65922 17.9052 9.43025 17.7364 9.26142C17.5676 9.0926 17.3387 8.99776 17.1 8.99776Z"
              fill="#03267A"
            />
          </svg>
          Upload Phiếu
        </div>-->
        <div class="flex items-center">
          <span @click="ModalCreate" class="fs-14 fw-700 text-grey-900 cursor-pointer">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="mr-2"
            >
              <path
                d="M8.99984 0.666748C7.35166 0.666748 5.7405 1.15549 4.37009 2.07117C2.99968 2.98685 1.93158 4.28834 1.30084 5.81105C0.670115 7.33377 0.505087 9.00933 0.82663 10.6258C1.14817 12.2423 1.94185 13.7272 3.10728 14.8926C4.27272 16.0581 5.75758 16.8517 7.37409 17.1733C8.9906 17.4948 10.6662 17.3298 12.1889 16.6991C13.7116 16.0683 15.0131 15.0002 15.9288 13.6298C16.8444 12.2594 17.3332 10.6483 17.3332 9.00008C17.3332 7.90573 17.1176 6.8221 16.6988 5.81105C16.28 4.80001 15.6662 3.88135 14.8924 3.10752C14.1186 2.3337 13.1999 1.71987 12.1889 1.30109C11.1778 0.882296 10.0942 0.666748 8.99984 0.666748ZM8.99984 15.6667C7.6813 15.6667 6.39237 15.2758 5.29604 14.5432C4.19971 13.8107 3.34523 12.7695 2.84064 11.5513C2.33606 10.3331 2.20404 8.99269 2.46127 7.69948C2.71851 6.40627 3.35345 5.21839 4.2858 4.28604C5.21815 3.35369 6.40603 2.71875 7.69924 2.46151C8.99245 2.20428 10.3329 2.3363 11.5511 2.84088C12.7692 3.34547 13.8104 4.19995 14.543 5.29628C15.2755 6.39261 15.6665 7.68154 15.6665 9.00008C15.6665 10.7682 14.9641 12.4639 13.7139 13.7141C12.4636 14.9644 10.768 15.6667 8.99984 15.6667ZM12.3332 8.16675H9.83317V5.66675C9.83317 5.44573 9.74538 5.23377 9.5891 5.07749C9.43282 4.92121 9.22085 4.83342 8.99984 4.83342C8.77883 4.83342 8.56687 4.92121 8.41059 5.07749C8.25431 5.23377 8.16651 5.44573 8.16651 5.66675V8.16675H5.66651C5.44549 8.16675 5.23353 8.25455 5.07725 8.41083C4.92097 8.56711 4.83317 8.77907 4.83317 9.00008C4.83317 9.2211 4.92097 9.43306 5.07725 9.58934C5.23353 9.74562 5.44549 9.83342 5.66651 9.83342H8.16651V12.3334C8.16651 12.5544 8.25431 12.7664 8.41059 12.9227C8.56687 13.079 8.77883 13.1667 8.99984 13.1667C9.22085 13.1667 9.43282 13.079 9.5891 12.9227C9.74538 12.7664 9.83317 12.5544 9.83317 12.3334V9.83342H12.3332C12.5542 9.83342 12.7662 9.74562 12.9224 9.58934C13.0787 9.43306 13.1665 9.2211 13.1665 9.00008C13.1665 8.77907 13.0787 8.56711 12.9224 8.41083C12.7662 8.25455 12.5542 8.16675 12.3332 8.16675Z"
                fill="#03267A"
              />
            </svg>
            Thêm Phiếu mới
          </span>
        </div>
      </div>
      <div v-loading="loading">
        <el-table
          :data="medicalOrder"
          :default-sort="{ prop: 'date', order: 'descending' }"
          style="width: 100%"
          row-class-name="text-black text-sm"
          header-cell-class-name="text-black text-base font-semibold"
          class="cursor-pointer"
          @row-click="goToViewDetail"
        >
          <el-table-column
            :formatter="(row) => row.name"
            label="Tên phiếu"
          ></el-table-column>
          <el-table-column
            :formatter="(row) => appUtils.formatDateTime(row.date)"
            label="Ngày giờ truyền"
          ></el-table-column>
          <el-table-column
            :formatter="(row) => getDoctorName(row.treatment_doctor_id)"
            label="Bác sĩ điều trị"
          ></el-table-column>
          <el-table-column
            :formatter="(row) => getDoctorName(row.user_id)"
            label="Người tạo phiếu"
            class-name="text-center"
            width="240px"
          ></el-table-column>
          <el-table-column label="" class-name="text-center" width="150px">
            <template slot-scope="scope">
              <el-button
                @click.stop="openModalSignPDF(scope.row, true)"
                type="primary"
                size="mini"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill="currentColor"
                    d="M9.021 1.772a2.445 2.445 0 0 1 3.458 3.457l-.272.271l.086.086a2 2 0 0 1 0 2.828l-1.44 1.44a.5.5 0 0 1-.707-.707l1.44-1.44a1 1 0 0 0 0-1.414l-.086-.086l-5.646 5.647a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.595-.643l1.25-3.75a.5.5 0 0 1 .12-.195l6.625-6.625Zm2.75.707a1.445 1.445 0 0 0-2.042 0L3.187 9.02l-.925 2.774l2.982-.745l6.527-6.527a1.445 1.445 0 0 0 0-2.043ZM4.967 15c-1.235 0-2.208-.566-2.855-1.107l1.284-.32a3.2 3.2 0 0 0 1.57.427c.406 0 .824-.164 1.27-.457c.447-.293.878-.687 1.314-1.095l.113-.107c.385-.361.784-.737 1.166-.996c.408-.278.95-.53 1.517-.311c.376.144.62.41.791.736c.161.306.272.688.38 1.105c.05.19.133.374.23.498a.46.46 0 0 0 .114.112c.025.015.036.015.039.015c.122 0 .331-.082.63-.286c.185-.126.344-.252.502-.379c.098-.078.197-.157.302-.235c.279-.209.52-.349.697-.438a3.05 3.05 0 0 1 .278-.124l.02-.008l.007-.002l.003-.001h.001l.16.473l-.159-.474a.5.5 0 0 1 .321.947l-.004.002a2.141 2.141 0 0 0-.175.08c-.13.064-.321.174-.55.346c-.059.043-.135.104-.223.174c-.181.143-.409.324-.618.466c-.31.212-.741.46-1.192.46c-.436 0-.751-.265-.946-.517a2.435 2.435 0 0 1-.405-.858c-.11-.423-.196-.7-.296-.89c-.09-.168-.17-.232-.266-.27c-.082-.03-.245-.033-.595.206c-.313.212-.655.533-1.058.912l-.1.093c-.431.405-.92.855-1.449 1.202c-.53.348-1.14.621-1.818.621Z"
                  />
                </svg>
                <span class="fs-14"> {{ $t("Bệnh nhân ký") }}</span>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="flex justify-content-end mt-3">
          <el-pagination
            v-if="medicalOrder"
            background
            layout="prev, pager, next"
            :total="medicalOrderPaging.total"
            :page-size="parseInt(medicalOrderPaging.per_page)"
            @current-change="handleCurrentPage"
          ></el-pagination>
        </div>
      </div>
    </div>

    <Detail
      :medicalOrderId="medicalOrderId"
      :triggerPatientSign="triggerPatientSign"
      @refresh="getListMedicalOrder"
      @onSignPatientLoading="(isProcessed) => (loading = isProcessed)"
    />
    <CreatePYLT
      ref="ModalCreateGiayYLenhTruyen"
      :type="'create'"
      @handleShowDetail="handleShowDetail"
      @refresh="getListMedicalOrder"
    />
    <ModalSignPDF
      ref="ListYLenh_ModalSignPDF"
      containerIDProps="ListYLenh_ContainerSignPDFID"
      elementIDProps="ListYLenh_SignPDFID"
      imageIDProps="ListYLenh_SignPDFImageID"
      @onSuccess="handleSignDocumentSuccess"
    />
    <PdfViewer
      ref="ListYLenh_PdfViewer"
      containerIDProps="ContainerListYLenh_PDFViewerID"
      elementIDProps="ListYLenh_PDFViewerID"
    />
  </div>
</template>

<script>
import appUtils from '../../../utils/appUtils'
import { ENVELOPE_DOCUMENT_TYPE } from '../../../utils/constants'
import { mixinSignPdf } from '../../../utils/mixinSignPdf'
import PdfViewer from '../../PdfViewer/PdfViewer.vue'
import ModalSignPDF from '../../Signature/ModalSignPDF.vue'
import CreatePYLT from './CreatePYLT'
import Detail from './Detail'

export default {
  name: 'PhieuYLenhTruyenList',
  components: { Detail, CreatePYLT, ModalSignPDF, PdfViewer },
  mixins: [mixinSignPdf],
  data () {
    return {
      loading: false,
      showDetail: false,
      medicalOrder: null,
      medicalOrderPaging: null,
      appUtils,
      medicalOrderId: null,
      doctors: [],
      triggerPatientSign: 0
    }
  },
  watch: {
    showDetail (val) {
      if (!val) this.getListMedicalOrder()
    }
  },
  async created () {
    this.$eventBus.$on('syncVimes', this.handleMount)
    await this.getDoctors()
  },
  beforeDestroy () {
    this.$eventBus.$off('syncVimes', this.handleMount)
  },
  mounted () {
    const self = this
    this.handleMount()

    self.$nextTick(function () {
      window.$('#ModalChiTietPGMTM').on('hidden.bs.modal', function (e) {
        self.getListMedicalOrder()
      })
    })
  },
  methods: {
    handleMount () {
      let self = this
      if (!self.showDetail) self.getListMedicalOrder()
    },
    getDoctorName (user_id) {
      if (!user_id || !this.doctors?.length) return ''
      const doctor = this.doctors?.find((d) => d.user_id === user_id)
      if (!doctor || typeof doctor === 'undefined') return ''
      return doctor.name
    },
    handleCurrentPage (page) {
      let query = Object.assign({}, this.$route.query)
      query.page = page
      this.$router.replace({ query }).catch((_) => {})
      this.getListMedicalOrder()
    },
    async getListMedicalOrder () {
      let id = this.$route.params.id
      if (!id) {
        return
      }
      this.loading = true
      const params = {
        emr_id: id,
        limit: 50,
        page: this.$route.query.page || 1,
        sort: 'date',
        sort_by: 'desc'
      }

      await this.$rf
        .getRequest('DoctorRequest')
        .getListMedicalOrder(params)
        .then((r) => {
          this.medicalOrder = r.data?.data?.data
          this.medicalOrderPaging = r.data?.data?.meta || {
            per_page: 10,
            total: r.data?.data?.length
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleShowDetail (row) {
      this.medicalOrderId = row.id
      window.$('#modalViewPYLT').modal('show')
    },
    async goToViewDetail (row) {
      const envelopeInfo = await this.openModalSignPDF(row)

      // this.$nextTick(() => {

      // })

      if (envelopeInfo) return

      this.handleShowDetail(row)
    },
    ModalCreate () {
      this.$refs.ModalCreateGiayYLenhTruyen.openModal(true)
      //   window.$('#ModalPYLT').modal(show ? 'show' : 'hide')
    },
    async getDoctors () {
      const clinic_id = this.$clinicId
      await this.$rf
        .getRequest('DoctorRequest')
        .getDoctorsOfWorkspace(clinic_id, { limit: 1000 })
        .then((res) => {
          this.doctors = res.data?.data
        })
    },
    async openModalSignPDF (docInfo, isPatientSign = false) {
      console.log({ isPatientSign })
      this.loading = true
      const documentType = ENVELOPE_DOCUMENT_TYPE.MEDICAL_ORDER_FORM

      const viewRef = 'ListYLenh_PdfViewer'
      const signRef = 'ListYLenh_ModalSignPDF'

      const envelopeInfo = await this.handleCheckSignEnvelope(
        documentType,
        docInfo?.id,
        viewRef,
        signRef,
        isPatientSign
      )

      if (!envelopeInfo && isPatientSign) {
        this.medicalOrderId = docInfo?.id
        this.$nextTick(() => {
          this.triggerPatientSign++
        })
      } else {
        this.loading = false
      }

      return envelopeInfo
    },
    getUserByRole (role, callback, isPatientSign) {
      let user
      let signer
      switch (role) {
        case 'chemical_mixer':
          const chemicalMixer = this.getDoctorInfo(this.form?.chemical_id)?.user
          if (!chemicalMixer) {
            // eslint-disable-next-line standard/no-callback-literal
            callback('Không tìm thấy thông tin Người pha hoá chất')
          } else {
            user = chemicalMixer
            if (user?.id === this.$user?.id && user?.id && !isPatientSign) {
              signer = user
              // eslint-disable-next-line standard/no-callback-literal
              callback(null, signer)
            }
          }
          break

        case 'infusion_nurse':
          const infusionNurse = this.getDoctorInfo(this.form?.infusion_id)?.user

          if (infusionNurse) {
            user = infusionNurse
            if (user?.id === this.$user?.id && user?.id && !isPatientSign) {
              signer = user
              // eslint-disable-next-line standard/no-callback-literal
              callback(null, signer)
            }
          } else {
            // eslint-disable-next-line standard/no-callback-literal
            callback('Không tìm thấy thông tin Người tiêm truyền')
          }

          break

        case 'treatment_doctor':
          const treatmentDoctor = this.getDoctorInfo(this.form?.treatment_doctor_id)
            ?.user

          if (treatmentDoctor) {
            user = treatmentDoctor
            if (user?.id === this.$user?.id && user?.id && !isPatientSign) {
              signer = user
              // eslint-disable-next-line standard/no-callback-literal
              callback(null, signer)
            }
          } else {
            // eslint-disable-next-line standard/no-callback-literal
            callback('Không tìm thấy thông tin Bác sĩ điều trị')
          }

          break

        case 'patient':
          const patient = {
            id: this.person?.user?.id,
            name: this.person?.name,
            email: this.person?.user?.email,
            person_id: this.person.id
          }

          user = patient
          if (isPatientSign) {
            signer = user
            // eslint-disable-next-line standard/no-callback-literal
            callback(null, signer)
          }

          break
        default:
          break
      }

      return user
    },

    async handleSignDocumentSuccess () {
      // window.$('#modalViewPYLT').modal('hide')
    }
  }
}
</script>
